// src/data/robots.js
// Specifications verified against manufacturer sources on 2026-10-01 and vendor reviewed.
// Every figure traceable to sourceUrl. Never edit a spec without updating specsVerifiedOn.

export const ROBOTS = [
  {
    slug: "visionnav-vnp15",
    vendor: "VisionNav Robotics", vendorSlug: "visionnav",
    model: "VNP 15", displayName: "VisionNav VNP 15",
    type: "autonomous-forklift", typeLabel: "Autonomous Counterbalance Stacker",
    summary: "A 1,500 kg counterbalance stacker that handles pallet putaway and ground to rack transport using 3D SLAM, with no tape or reflectors required.",
    payloadKg: 1500,
    liftHeightMm: 3000, liftHeightOptionsMm: [3500, 4000, 4500],
    footprintMm: { l: null, w: null, h: null }, weightKg: null,
    maxSpeedMs: 1.5, turningRadiusMm: 1490, rotationDiameterMm: null,
    minAisleMm: 1424, groundClearanceMm: null,
    navigation: ["3D SLAM"], positioningAccuracyMm: 20,
    battery: { chemistry: null, voltageV: null, capacityAh: null, runtimeHours: null,
               chargeStrategy: ["manual", "automatic"], chargeTimeMinutes: null },
    fleetSoftware: [], vda5050: null, environment: "indoor", ipRating: null,
    jobs: ["pallets"],
    specNotes: "Stacking accuracy plus or minus 20 mm. Minimum turning aisle 3,300 mm. Rated capacity derates with taller masts, attachments or longer loads, and the published performance figures assume the standard 3,000 mm duplex mast.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://www.visionnav.com/product/detail/vnp15-pallet-stacker-agv",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/visionnav-vnp15.webp",
             alt: "VisionNav VNP 15 autonomous counterbalance stacker with forks lowered",
             width: 1200, height: 900, credit: "VisionNav Robotics", licenseStatus: "approved" }
  },
  {
    slug: "visionnav-vnsl14",
    vendor: "VisionNav Robotics", vendorSlug: "visionnav",
    model: "VNSL 14", displayName: "VisionNav VNSL 14",
    type: "autonomous-forklift", typeLabel: "Autonomous Slim Forklift",
    summary: "A 1,400 kg slim forklift built for 1.8 m aisles, with one-key switching between manual and automatic operation.",
    payloadKg: 1400,
    liftHeightMm: 1600, liftHeightOptionsMm: [2500, 3000],
    footprintMm: { l: null, w: null, h: null }, weightKg: null,
    maxSpeedMs: 1.3, turningRadiusMm: 1173, rotationDiameterMm: null,
    minAisleMm: 2250, groundClearanceMm: null,
    navigation: ["3D SLAM"], positioningAccuracyMm: null,
    battery: { chemistry: null, voltageV: null, capacityAh: null, runtimeHours: null,
               chargeStrategy: [], chargeTimeMinutes: null },
    fleetSoftware: [], vda5050: null, environment: "indoor", ipRating: null,
    jobs: ["pallets"],
    specNotes: "Shares the 3D SLAM perception stack with the VNP 15. The narrow chassis is the reason to choose this over the VNP 15 when aisle width is the binding constraint.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://www.visionnav.com/product/detail/vnsl14-slim-forklift-agv",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/visionnav-vnsl14.webp",
             alt: "VisionNav VNSL 14 autonomous slim forklift, narrow chassis with mast",
             width: 1200, height: 900, credit: "VisionNav Robotics", licenseStatus: "approved" }
  },
  {
    slug: "visionnav-vnk15",
    vendor: "VisionNav Robotics", vendorSlug: "visionnav",
    model: "VNK 15", displayName: "VisionNav VNK 15",
    type: "amr", typeLabel: "Platform AMR",
    summary: "A low-profile 1,500 kg platform AMR for top-lift handling, rated by VisionNav for continuous operation at low temperature.",
    payloadKg: 1500,
    liftHeightMm: 60, liftHeightOptionsMm: [],
    footprintMm: { l: null, w: null, h: null }, weightKg: null,
    maxSpeedMs: 1.8, turningRadiusMm: 1200, rotationDiameterMm: null,
    minAisleMm: null, groundClearanceMm: null,
    navigation: [], positioningAccuracyMm: null,
    battery: { chemistry: null, voltageV: null, capacityAh: null, runtimeHours: null,
               chargeStrategy: [], chargeTimeMinutes: null },
    fleetSoftware: [], vda5050: null, environment: "indoor", ipRating: null,
    jobs: ["deck", "rack"],
    specNotes: "Built for high-load top-lift handling and large-scale fleet scheduling. VisionNav states stable continuous operation in ultra-low temperature conditions, which makes this the cold storage candidate in the range. VisionNav does not publish navigation method, overall footprint or battery specification for this model.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://www.visionnav.com/product/detail/vnk15agfrobot",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/visionnav-vnk15.webp",
             alt: "VisionNav VNK 15 low-profile platform AMR with top lift plate",
             width: 1200, height: 900, credit: "VisionNav Robotics", licenseStatus: "approved" }
  },
  {
    slug: "kuka-kmp-1500",
    vendor: "KUKA", vendorSlug: "kuka",
    model: "KMP 1500P diffDrive", displayName: "KUKA KMP 1500P diffDrive",
    type: "amr", typeLabel: "Mobile Robot Platform",
    summary: "A 1,500 kg differential-drive AMR platform that reads floor QR codes for plus or minus 5 mm positioning and charges inductively for continuous operation.",
    payloadKg: 1500,
    liftHeightMm: 60, liftHeightOptionsMm: [],
    footprintMm: { l: null, w: null, h: null }, weightKg: null,
    maxSpeedMs: 1.8, turningRadiusMm: null, rotationDiameterMm: null,
    minAisleMm: null, groundClearanceMm: null,
    navigation: ["SLAM", "QR code"], positioningAccuracyMm: 5,
    battery: { chemistry: null, voltageV: null, capacityAh: null, runtimeHours: null,
               chargeStrategy: ["inductive", "conductive-dock"], chargeTimeMinutes: null },
    fleetSoftware: ["KUKA.AMR Fleet"], vda5050: null, environment: "indoor", ipRating: "IP54",
    jobs: ["deck", "rack"],
    specNotes: "Reaches 1.8 m/s unloaded and 1.5 m/s loaded. A camera underneath the platform reads floor QR codes for positioning, and a second on-platform camera identifies the load. Safety provisions are 3D cameras and laser scanners at IP54. Inductive charging supports 24/7 operation. KUKA also sells an older omnidirectional KMP 1500 omni on Mecanum wheels, which is a different machine.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://www.kuka.com/en-de/products/amr-autonomous-mobile-robotics/mobile-platforms",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/kuka-kmp-1500.webp",
             alt: "KUKA KMP 1500P diffDrive mobile robot platform with circular lift plate",
             width: 1200, height: 900, credit: "KUKA", licenseStatus: "approved" }
  },
  {
    slug: "kuka-kmp-600",
    vendor: "KUKA", vendorSlug: "kuka",
    model: "KMP 600P diffDrive", displayName: "KUKA KMP 600P diffDrive",
    type: "amr", typeLabel: "Mobile Robot Platform",
    summary: "A compact 600 kg AMR platform for tight production areas, switchable between SLAM and floor QR navigation, with inductive charging for 24/7 running.",
    payloadKg: 600,
    liftHeightMm: 80, liftHeightOptionsMm: [],
    footprintMm: { l: 980, w: 686, h: 270 }, weightKg: null,
    maxSpeedMs: null, turningRadiusMm: null, rotationDiameterMm: null,
    minAisleMm: null, groundClearanceMm: null,
    navigation: ["SLAM", "QR code"], positioningAccuracyMm: null,
    battery: { chemistry: null, voltageV: null, capacityAh: null, runtimeHours: null,
               chargeStrategy: ["inductive"], chargeTimeMinutes: null },
    fleetSoftware: ["KUKA.AMR Fleet"], vda5050: true, environment: "indoor", ipRating: "IP54",
    jobs: ["deck", "totes"],
    specNotes: "Navigation switches remotely between SLAM and floor QR codes, which suits production areas whose layout changes often. Two 3D cameras. Noise level 75 dB(A). Configured through KUKA.AMR Fleet with no programming. KUKA publishes a 2 m/s maximum for the sibling KMP 600-S diffDrive but does not publish a figure for the 600P.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://www.kuka.com/en-de/products/amr-autonomous-mobile-robotics/mobile-platforms/kmp-600p-diffdrive",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/kuka-kmp-600.webp",
             alt: "KUKA KMP 600P diffDrive mobile robot platform with lift plate and safety decals",
             width: 1200, height: 900, credit: "KUKA", licenseStatus: "approved" }
  },
  {
    slug: "otto-100",
    vendor: "OTTO by Rockwell Automation", vendorSlug: "otto",
    model: "OTTO 100", displayName: "OTTO 100",
    type: "amr", typeLabel: "Autonomous Mobile Robot",
    summary: "A 150 kg AMR that turns in place and fits a 1,099 mm one-way aisle, built for kit and small parts delivery between stations.",
    payloadKg: 150,
    liftHeightMm: 62, liftHeightOptionsMm: [],
    footprintMm: { l: 740, w: 550, h: 308 }, weightKg: 107,
    maxSpeedMs: 2.0, turningRadiusMm: 0, rotationDiameterMm: null,
    minAisleMm: 1099, groundClearanceMm: 6,
    navigation: ["2D SLAM"], positioningAccuracyMm: 10,
    battery: { chemistry: null, voltageV: 26.4, capacityAh: 40, runtimeHours: 6,
               chargeStrategy: ["opportunity", "manual"], chargeTimeMinutes: 18 },
    fleetSoftware: ["OTTO Fleet Manager"], vda5050: null, environment: "indoor", ipRating: "IP20",
    jobs: ["totes", "deck"],
    specNotes: "Turns in place at up to 1.25 rad/s. Two-way minimum aisle 1,975 mm. Traversable floor gap 13 mm. Docking precision plus or minus 10 mm, docking speed 0.3 m/s. Charges from 10 to 90 percent in 18 minutes on the autonomous supercharger at 98 A, with a 25 A manual trickle charger also available. Sensing is a Hokuyo safety laser scanner, a 3D camera covering 90 degrees to the front and a time-of-flight rear sensor. Rated capacity includes payload, attachments and the cart if there is one. IP20 means dry indoor environments only. Standards: CE marked, ANSI/ITSDF B56.5, RIA R15.08-1, ISO 12100, ISO 13849-1 and ISO 3691-4.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://ottomotors.com/100",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/otto-100.webp",
             alt: "OTTO 100 autonomous mobile robot, brushed steel chassis with flat top deck",
             width: 1200, height: 900, credit: "OTTO by Rockwell Automation", licenseStatus: "approved" }
  },
  {
    slug: "seer-slr-1000",
    vendor: "SEER Robotics", vendorSlug: "seer",
    model: "SLR-1000EU", displayName: "SEER SLR-1000EU",
    type: "underdrive", typeLabel: "Safety Lifting Robot",
    summary: "A 1,000 kg underdrive AMR that drives beneath a cart or rack and lifts it, using laser SLAM with no reflectors and a 1,092 mm minimum aisle.",
    payloadKg: 1000,
    liftHeightMm: 60, liftHeightOptionsMm: [],
    footprintMm: { l: 1330, w: 952, h: 290.5 }, weightKg: 265,
    maxSpeedMs: 1.5, turningRadiusMm: null, rotationDiameterMm: 1457.4,
    minAisleMm: 1092, groundClearanceMm: 30.5,
    navigation: ["Laser SLAM"], positioningAccuracyMm: 5,
    battery: { chemistry: "LiFePO4", voltageV: 48, capacityAh: 40, runtimeHours: 7,
               chargeStrategy: ["manual", "automatic"], chargeTimeMinutes: 120 },
    fleetSoftware: [], vda5050: null, environment: "indoor", ipRating: null,
    jobs: ["rack"],
    specNotes: "Formerly sold as the AMB-1000JS. Lifting platform 1,300 x 920 mm with a 60 plus or minus 1 mm stroke. Angular accuracy plus or minus 1 degree. Two lidars and no reflectors required. CE certified to ISO 3691-4:2020. Charges from 10 to 80 percent in under 2 hours.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://seer-robotics.ai/amr/liftingrobot",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/seer-slr-1000.webp",
             alt: "SEER SLR-1000EU safety lifting robot with flat lifting platform",
             width: 1200, height: 900, credit: "SEER Robotics", licenseStatus: "approved" }
  },
  {
    slug: "seer-sjv-sw600",
    vendor: "SEER Robotics", vendorSlug: "seer",
    model: "SJV-SW600", displayName: "SEER SJV-SW600",
    type: "underdrive", typeLabel: "Rotary Lifting Robot",
    summary: "A 600 kg rotary jacking AMR whose lift plate turns independently of the chassis, so a load keeps its orientation down a 790 mm aisle.",
    payloadKg: 600,
    liftHeightMm: 60, liftHeightOptionsMm: [],
    footprintMm: { l: 950, w: 650, h: 250 }, weightKg: 170,
    maxSpeedMs: 1.5, turningRadiusMm: null, rotationDiameterMm: 1015,
    minAisleMm: 790, groundClearanceMm: 25,
    navigation: ["Laser SLAM", "QR code", "Reflector"], positioningAccuracyMm: 5,
    battery: { chemistry: "LiFePO4", voltageV: 48, capacityAh: 24, runtimeHours: 8,
               chargeStrategy: ["manual", "automatic"], chargeTimeMinutes: 120 },
    fleetSoftware: [], vda5050: null, environment: "indoor", ipRating: null,
    jobs: ["rack", "totes"],
    specNotes: "Reaches 2.0 m/s unloaded and 1.5 m/s at full load. Lifting platform 924 x 650 mm with a 60 plus or minus 2 mm stroke. Front guidance laser and rear obstacle laser. The rotating lift structure, which turns the load independently of the chassis, is what gets this machine down a 790 mm aisle, the narrowest in the catalogue.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://www.seer-group.com/agvs/amr-robots/SJV-SW600",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/seer-sjv-sw600.webp",
             alt: "SEER SJV-SW600 rotary lifting robot with circular rotating lift plate",
             width: 1200, height: 900, credit: "SEER Robotics", licenseStatus: "approved" }
  },
  {
    slug: "abb-flexley-tug-t702",
    vendor: "ABB", vendorSlug: "abb",
    model: "Flexley Tug AMR T702", displayName: "ABB Flexley Tug AMR T702",
    type: "tunnel", typeLabel: "Tunnel and Tow AMR",
    summary: "A bidirectional tow and tunnel unit rated to 2,000 kg on magnetic navigation, dropping to 1,000 kg when run on natural SLAM.",
    payloadKg: 2000,
    liftHeightMm: null, liftHeightOptionsMm: [],
    footprintMm: { l: 2104, w: 500, h: 230 }, weightKg: null,
    maxSpeedMs: 1.5, turningRadiusMm: 600, rotationDiameterMm: null,
    minAisleMm: null, groundClearanceMm: null,
    navigation: ["Magnetic tape", "RFID tags"], positioningAccuracyMm: 10,
    battery: { chemistry: "Li-ion", voltageV: 48, capacityAh: 40, runtimeHours: null,
               chargeStrategy: ["online-brush", "manual"], chargeTimeMinutes: null },
    fleetSoftware: [], vda5050: null, environment: "indoor", ipRating: null,
    jobs: ["tow"],
    specNotes: "Towing capacity 1,600 N. Speed range 0.01 to 1.5 m/s, falling to 1.2 m/s on magnetic navigation. SLAM and magnetic dual navigation is available as an option, and selecting it halves rated payload from 2,000 kg to 1,000 kg. That trade-off sits in a footnote on ABB's datasheet, and stating it plainly here is the point of this page. Redundant safety PLC with two safety lasers. In base configuration this is arguably an AGV rather than an AMR, which makes it the worked example for the /amr-vs-agv page.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://new.abb.com/docs/librariesprovider89/default-document-library/abb_datasheet_amr-t702.pdf",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/abb-flexley-tug-t702.webp",
             alt: "ABB Flexley Tug AMR tow and tunnel unit, low-profile bidirectional chassis",
             width: 1200, height: 900, credit: "ABB", licenseStatus: "approved" }
  },
  {
    slug: "bluepath-mouse-tunnel-high",
    vendor: "BluePath Robotics", vendorSlug: "bluepath",
    model: "Mouse/Tunnel High", displayName: "BluePath Mouse/Tunnel High",
    type: "tunnel", typeLabel: "Tunnel and Tow AMR",
    summary: "A 1,000 kg omnidirectional tunnel AMR with bidirectional pin engagement, running hybrid natural navigation and line tracking.",
    payloadKg: 1000,
    liftHeightMm: null, liftHeightOptionsMm: [],
    footprintMm: { l: 2100, w: 500, h: 230 }, weightKg: 450,
    maxSpeedMs: 1.5, turningRadiusMm: null, rotationDiameterMm: null,
    minAisleMm: null, groundClearanceMm: null,
    navigation: ["Natural feature", "Line tracking"], positioningAccuracyMm: 10,
    battery: { chemistry: null, voltageV: null, capacityAh: 62, runtimeHours: null,
               chargeStrategy: [], chargeTimeMinutes: null },
    fleetSoftware: [], vda5050: true, environment: "indoor", ipRating: null,
    jobs: ["tow"],
    specNotes: "Omnidirectional drive with 3D object detection and bidirectional pin engagement. The Mouse/Tunnel Low is the smaller sibling at 500 kg, and the pair is a clean illustration of the payload against maneuverability trade.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://bluepathrobotics.com/product/mouse-tunnel-high-amr/",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/bluepath-mouse-tunnel-high.webp",
             alt: "BluePath Mouse/Tunnel High tunnel AMR with pin engagement",
             width: 1200, height: 900, credit: "BluePath Robotics", licenseStatus: "approved" }
  },
  {
    slug: "bluepath-mouse-tunnel-low",
    vendor: "BluePath Robotics", vendorSlug: "bluepath",
    model: "Mouse/Tunnel Low", displayName: "BluePath Mouse/Tunnel Low",
    type: "tunnel", typeLabel: "Tunnel and Tow AMR",
    summary: "A 500 kg tunnel AMR only 230 mm tall, built to run beneath racks and fixed-height structures that other tow units cannot clear.",
    payloadKg: 500,
    liftHeightMm: null, liftHeightOptionsMm: [],
    footprintMm: { l: 1400, w: 500, h: 230 }, weightKg: 230,
    maxSpeedMs: 1.5, turningRadiusMm: null, rotationDiameterMm: null,
    minAisleMm: null, groundClearanceMm: null,
    navigation: ["Visual SLAM", "Laser SLAM", "Line tracking"], positioningAccuracyMm: 10,
    battery: { chemistry: null, voltageV: null, capacityAh: 40, runtimeHours: null,
               chargeStrategy: [], chargeTimeMinutes: null },
    fleetSoftware: [], vda5050: true, environment: "indoor", ipRating: null,
    jobs: ["tow", "rack"],
    specNotes: "Pinned tow system with 3D object detection and precise docking. The 230 mm height is the reason to specify this unit: it reaches under racks and fixed structures where a taller tow AMR cannot go.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://bluepathrobotics.com/product/mouse-tunnel/",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/bluepath-mouse-tunnel-low.webp",
             alt: "BluePath Mouse/Tunnel Low low-profile tunnel AMR, 230 mm tall chassis",
             width: 1200, height: 900, credit: "BluePath Robotics", licenseStatus: "approved" }
  },
  {
    slug: "bluepath-tugger-medium-4000",
    vendor: "BluePath Robotics", vendorSlug: "bluepath",
    model: "Tugger Medium 4000", displayName: "BluePath Tugger Medium 4000",
    type: "tugger", typeLabel: "Tow AMR",
    summary: "A 4,000 kg towing AMR for bulk dolly transfer along distribution corridors, the heaviest towing unit in the catalog.",
    payloadKg: 4000,
    liftHeightMm: null, liftHeightOptionsMm: [],
    footprintMm: { l: 1200, w: 900, h: 2020 }, weightKg: 800,
    maxSpeedMs: 1.5, turningRadiusMm: null, rotationDiameterMm: null,
    minAisleMm: null, groundClearanceMm: null,
    navigation: ["Natural feature", "Line tracking"], positioningAccuracyMm: 10,
    battery: { chemistry: null, voltageV: null, capacityAh: 105, runtimeHours: null,
               chargeStrategy: [], chargeTimeMinutes: null },
    fleetSoftware: [], vda5050: true, environment: "indoor", ipRating: null,
    jobs: ["tow"],
    specNotes: "Differential drive with obstacle avoidance and precise docking. BluePath lists the dimensions as 900 x 1200 x 2020 mm. It sits between the Tugger Low at 2,000 kg and the Tugger Medium 6000, so this is the unit to quote when a Tugger Low is marginal.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://bluepathrobotics.com/product/tugger-medium-4000-2/",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/bluepath-tugger-medium-4000.webp",
             alt: "BluePath Tugger Medium 4000 towing AMR with vertical tow post",
             width: 1200, height: 900, credit: "BluePath Robotics", licenseStatus: "approved" }
  },
  {
    slug: "bluepath-underdrive-omni",
    vendor: "BluePath Robotics", vendorSlug: "bluepath",
    model: "Underdrive Omnidirectional", displayName: "BluePath Underdrive Omnidirectional",
    type: "underdrive", typeLabel: "Underdrive AMR",
    summary: "A 1,000 kg omnidirectional underdrive AMR for pallet and rack transport in space-constrained layouts, running visual and laser SLAM.",
    payloadKg: 1000,
    liftHeightMm: null, liftHeightOptionsMm: [],
    footprintMm: { l: 1850, w: 850, h: 350 }, weightKg: null,
    maxSpeedMs: 1.5, turningRadiusMm: null, rotationDiameterMm: null,
    minAisleMm: null, groundClearanceMm: null,
    navigation: ["Visual SLAM", "Laser SLAM", "Line tracking"], positioningAccuracyMm: 10,
    battery: { chemistry: null, voltageV: null, capacityAh: 40, runtimeHours: null,
               chargeStrategy: [], chargeTimeMinutes: null },
    fleetSoftware: [], vda5050: true, environment: "indoor", ipRating: null,
    jobs: ["rack"],
    specNotes: "Safety rated PLd. Omnidirectional mobility is the reason to choose this over the differential Underdrive when a layout needs flexible direction changes in a dense area.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://bluepathrobotics.com/product/underdrive-omnidirectional/",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/bluepath-underdrive-omni.webp",
             alt: "BluePath Underdrive Omnidirectional AMR, flat low-profile chassis",
             width: 1200, height: 900, credit: "BluePath Robotics", licenseStatus: "approved" }
  },
  {
    slug: "wheelme-genius-2",
    vendor: "wheel.me", vendorSlug: "wheelme",
    model: "Genius 2", displayName: "wheel.me Genius 2",
    type: "autonomous-wheel", typeLabel: "Autonomous Wheel System",
    summary: "A set of four autonomous drive wheels that converts an existing cart, rack or trolley into a mobile robot, sold as a service rather than a capital purchase.",
    payloadKg: 250,
    liftHeightMm: null, liftHeightOptionsMm: [],
    footprintMm: { l: 269, w: 193, h: 134 }, weightKg: 4.6,
    maxSpeedMs: null, turningRadiusMm: null, rotationDiameterMm: null,
    minAisleMm: null, groundClearanceMm: null,
    navigation: ["Laser SLAM", "Visual SLAM"], positioningAccuracyMm: null,
    battery: { chemistry: "Li-ion", voltageV: null, capacityAh: 20, runtimeHours: 11,
               chargeStrategy: ["opportunity", "hot-swap"], chargeTimeMinutes: null },
    fleetSoftware: [], vda5050: null, environment: "indoor", ipRating: null,
    jobs: ["retrofit"],
    specNotes: "Rated at 250 kg (550 lb) per four-wheel set. Deployed in sets of four or eight, one of which acts as the controller. The main wheel measures 193 x 269 x 134 mm at 4.6 kg excluding battery, the supporter wheel 193 x 186 x 134 mm at 3.9 kg. Mecanum omnidirectional with lidar and 360 degree cameras. Replaceable 10 Ah and 20 Ah batteries give 5.5 to 11 hours depending on payload and mission, hot-swappable in minutes, with opportunity charging at a TUV SUD certified Power Station. Sold as Robotics as a Service, which is a different commercial model from everything else in this catalogue and worth saying plainly.",
    magDeployed: false, magInLab: false, magNotes: "", magApplications: [], faq: [],
    sourceUrl: "https://wheel.me",
    specsVerifiedOn: "2026-10-01", vendorReviewed: true,
    image: { src: "/images/equipment/wheelme-genius-2.webp",
             alt: "wheel.me Genius 2 autonomous drive wheel module with lidar and camera array",
             width: 1200, height: 900, credit: "wheel.me", licenseStatus: "approved" }
  }
];
